import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import axios from "axios";
import CreaComentarios from "views/Crea/CreaComentarios";
import { useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import CargaAnexo from "./CargarAnexos";
import ContratosFirmadoIcontec from "views/Crea/ContratoFirmadoIcontec";
import ContratosFirmadosCliente from "views/Crea/ContratosFirmadosCliente";

import Pruebas from "./PruebaHtmlPdf";
import AñadirTecnico from "./AñadirTecnico";

import ContratoVariablesTabla from "views/Crea/ContratosVariables copy";
import OtrosSi from "./OtrosSi";
import TiemposContrato from "./TiemposContrato";
import ReasignarJuridico from "./ReasignarJuridico";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaDownload } from "react-icons/fa";
import HistorialSolicitud from "./HistorialSolicitud";

const Tables = () => {
  const { id } = useParams(); // este 'id' ahora es el correo encriptado
  let correo = "";

  try {
    // Decodificar primero URL y luego Base64
    correo = atob(decodeURIComponent(id));
  } catch (e) {
    console.error("Error al decodificar correo:", e);
  }
  const cookie = new Cookies();
  const [list, setList] = useState([]);
  const [list1, setList1] = useState([]);
  const [switchState, setSwitchState] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Puedes ajustar la cantidad de elementos por página
  const [searchTerm, setSearchTerm] = useState(""); // Estado para el término de búsqueda general
  const [modalOpen, setModalOpen] = useState(false); // Estado para el modal
  const [selectedItem, setSelectedItem] = useState(null); // Para el ítem seleccionado
  const tipoUsuarioId = cookie.get("tipo_Usuario");

  useEffect(() => {
    if (!tipoUsuarioId) {
      Swal.fire({
        icon: "warning",
        title: "Debe iniciar sesión",
        text: "Por favor, inicie sesión para continuar.",
        confirmButtonText: "Aceptar",
      }).then(() => {
        window.location.href = "/auth/login";
      });
    }
  }, [tipoUsuarioId]);

  useEffect(() => {
    // Mostrar loading al iniciar
    Swal.fire({
      title: "Cargando información...",
      text: "Por favor espera",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: `https://contratosback-dev.azurewebsites.net/api/v1/ObtenerUsuarios/${correo}`,
    })
      .then((Response) => {
        Swal.close(); // Cerrar el loading
        const data = Response.data;
        setList(data);

        if (data.length > 0) {
          const respuesta = data[0];
          cookie.set("id", respuesta.id, { path: "/" });
          cookie.set("Nombre", respuesta.nombre, { path: "/" });
          cookie.set("correo", respuesta.correo, { path: "/" });
          cookie.set("tipo_Usuario", respuesta.tipoUsuarioId, { path: "/" });
        } else {
          console.warn("No se encontraron usuarios.");
        }
      })
      .catch((error) => {
        Swal.close(); // Cerrar el loading si hay error
        Swal.fire({
          title: "Error",
          text: "No se pudo cargar la información del usuario",
          icon: "error",
        });
        console.error(error);
      });
  }, [id]);

  useEffect(() => {
    const fetchCasosAsignados = async () => {
      try {
        const response = await axios({
          auth: {
            username: "admin.icontec@icontec.org",
            password: "quAngEraMuSTerGerEDE",
          },
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
          method: "get",
          url: `https://contratosback-dev.azurewebsites.net/api/v1/ObtenerCasosAsignados/${cookie.get(
            "id"
          )}`,
        });

        const newData = response.data;

        // Comparar el nuevo JSON con el estado actual (list1)
        if (JSON.stringify(newData) !== JSON.stringify(list1)) {
          setList1(newData); // Actualizar la tabla si hay cambios

          // Actualizar el estado del switch si es necesario
          const updatedSwitchState = {};
          newData.forEach((item) => {
            updatedSwitchState[item.id] = item.aprobacionTecnica == 1;
          });
          setSwitchState(updatedSwitchState);
        }
      } catch (error) {
        console.log(error);
      }
    };

    // Configurar el temporizador para ejecutar fetchCasosAsignados cada 30 segundos
    const intervalId = setInterval(() => {
      fetchCasosAsignados();
    }, 3000); // 30,000 ms = 30 segundos

    return () => clearInterval(intervalId); // Limpiar el temporizador al desmontar el componente
  }, [list1, cookie]);

  const formatDate = (dateString) => {
    return dateString.split("T")[0];
  };

  // Filtrar datos usando el término de búsqueda general
  const filteredItems = list1.filter((item) => {
    const lowercasedFilter = searchTerm.toLowerCase();
    return (
      item.id.toString().includes(lowercasedFilter) ||
      item.fecha.includes(lowercasedFilter) ||
      item.nombreProveedor.toLowerCase().includes(lowercasedFilter) ||
      item.nit.toLowerCase().includes(lowercasedFilter) ||
      item.direccion.toLowerCase().includes(lowercasedFilter) ||
      item.ciudad.toLowerCase().includes(lowercasedFilter) ||
      item.telefono.toLowerCase().includes(lowercasedFilter)
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  const openModal = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  const exportToExcel = () => {
    // Convertimos los datos filtrados en formato plano
    const dataToExport = filteredItems.map((item) => ({
      "N° Contrato": item.id,
      "N° Contrato OtroSí": item.numeroContrato,
      Fecha: formatDate(item.fecha),
      "Paso Aprobación": `${item.descripcion} - ${item.nombre}`,
      "Nombre Del Proveedor": item.nombreProveedor,
      "N° Documento": item.nit,
      Dirección: item.direccion,
      Ciudad: item.ciudad,
      Teléfono: item.telefono,
      "Tipo De Contrato": item.tipoContrato,
    }));

    // Crear una hoja de cálculo
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Solicitudes");

    // Generar el archivo y descargarlo
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(blob, "Solicitudes_Gestion.xlsx");
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Solicitudes para gestión</h3>
              </CardHeader>

              {/* Buscador general */}
              <div className="px-4 py-2">
                <input
                  type="text"
                  placeholder="Buscar..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="form-control"
                />
                <br></br>
                <a>Genera reporte {""}</a>
                <Button
                  color="success"
                  onClick={exportToExcel}
                  title="Exportar a Excel"
                >
                  <FaDownload />
                </Button>
              </div>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Menú Acciones</th>
                    {cookie.get("tipo_Usuario") == 11 ? (
                      <th scope="col">Tiempos Del contrato</th>
                    ) : (
                      <th></th>
                    )}
                    <th scope="col">N° Contrato</th>
                    <th scope="col">N° Contrato OtroSí</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Paso Aprobación</th>
                    <th scope="col">Nombre Del Proveedor</th>
                    <th scope="col">N° Documento</th>
                    <th scope="col">Dirección</th>
                    <th scope="col">Ciudad</th>
                    <th scope="col">Teléfono</th>
                    <th scope="col">Tipo De Contrato</th>
                    <th scope="col">Historial</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <Button color="primary" onClick={() => openModal(item)}>
                          Acciones
                        </Button>
                      </td>
                      {cookie.get("tipo_Usuario") == 11 ||
                      cookie.get("tipo_Usuario") == 4 ? (
                        <td>
                          <TiemposContrato id={item.id} />
                        </td>
                      ) : (
                        <td></td>
                      )}

                      <td>{item.id}</td>
                      <td>
                        <OtrosSi numContrato={item.numeroContrato} />{" "}
                        {item.numeroContrato}
                      </td>

                      <td>{formatDate(item.fecha)}</td>
                      <td>
                        {item.descripcion}
                        <br></br>
                        {item.nombre}
                      </td>
                      <td>{item.nombreProveedor}</td>
                      <td>{item.nit}</td>
                      <td>{item.direccion}</td>
                      <td>{item.ciudad}</td>
                      <td>{item.telefono}</td>
                      <td>{item.tipoContrato}</td>
                      <td>
                        {cookie.get("tipo_Usuario") == 1 ||
                        cookie.get("tipo_Usuario") == 4 ? (
                          <HistorialSolicitud idSolicitud={item.id} />
                        ) : (
                          <h></h>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination className="pagination justify-content-end mb-0">
                    {Array.from({ length: totalPages }, (_, index) => (
                      <PaginationItem
                        key={index}
                        active={currentPage === index + 1}
                      >
                        <PaginationLink onClick={() => paginate(index + 1)}>
                          {index + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>

      {/* Modal de acciones */}
      <Modal isOpen={modalOpen} toggle={closeModal} style={{ zIndex: 900 }}>
        <ModalHeader toggle={closeModal}>Acciones</ModalHeader>
        <ModalBody>
          {selectedItem && (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {cookie.get("tipo_Usuario") == 1 ||
                cookie.get("tipo_Usuario") == 4 ? (
                  <ContratoVariablesTabla
                    id={selectedItem.id}
                    tipo={selectedItem.idTipoContrato}
                    nombreProveedor={selectedItem.nombreProveedor}
                  />
                ) : (
                  <></>
                )}
                {cookie.get("tipo_Usuario") != 5 ? (
                  <CargaAnexo id={selectedItem.id} />
                ) : (
                  <></>
                )}
                {cookie.get("tipo_Usuario") == 4 ||
                cookie.get("tipo_Usuario") == 1 ? (
                  <AñadirTecnico id={selectedItem.id} />
                ) : (
                  <></>
                )}
                {cookie.get("tipo_Usuario") == 5 ? (
                  <ContratosFirmadoIcontec id={selectedItem.id} />
                ) : (
                  <></>
                )}

                <CreaComentarios
                  id={selectedItem.id}
                  paso={selectedItem.pasoAprobacion}
                />

                {cookie.get("tipo_Usuario") == 1 ||
                cookie.get("tipo_Usuario") == 2 ? (
                  <ReasignarJuridico id={selectedItem.id} />
                ) : (
                  <></>
                )}
                <Pruebas id={selectedItem.id} />
              </div>
            </>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default Tables;
